// Libs
import { createApp } from "vue";

// Router
import { router } from './router';

const app = createApp({ template: '<router-view />' });

app.use(router);
app.mount('#app');